// extracted by mini-css-extract-plugin
export default {"infoList":"VQ08r0qWvJhFnMq0KfgS","regular":"gscbIhYwejnexktSxcax","danger":"kU5VuWscEKkxJrabDIwA","placeHolderShimmer":"LdDMKLOcz8V0sF4vn9KA"};